import { cn } from '@/lib/cn';

interface LogoProps {
  variant?: 'dark' | 'light' | 'mark';
  className?: string;
}

export function Logo({ variant = 'dark', className }: LogoProps): React.ReactNode {
  const isLight = variant === 'light';
  const stroke = isLight ? '#f5f3ee' : '#1f2419';
  const wordmarkColor = isLight ? '#f5f3ee' : '#1f2419';
  const subColor = isLight ? '#a3b48a' : '#3d4a32';

  if (variant === 'mark') {
    return (
      <svg
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Baumpflege Straesser"
        className={cn('shrink-0', className)}
      >
        <g
          transform="translate(12 8)"
          stroke={stroke}
          strokeWidth="3"
          strokeLinecap="square"
          fill="none"
        >
          <line x1="14" y1="6" x2="42" y2="6" />
          <line x1="8" y1="18" x2="48" y2="18" />
          <line x1="2" y1="30" x2="54" y2="30" />
          <line x1="8" y1="42" x2="48" y2="42" />
          <line x1="14" y1="54" x2="42" y2="54" />
          <line x1="28" y1="6" x2="28" y2="64" />
        </g>
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 320 80"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Baumpflege Straesser"
      className={cn('shrink-0', className)}
    >
      <g
        transform="translate(8 8)"
        stroke={stroke}
        strokeWidth="2.5"
        strokeLinecap="square"
        fill="none"
      >
        <line x1="14" y1="6" x2="42" y2="6" />
        <line x1="8" y1="18" x2="48" y2="18" />
        <line x1="2" y1="30" x2="54" y2="30" />
        <line x1="8" y1="42" x2="48" y2="42" />
        <line x1="14" y1="54" x2="42" y2="54" />
        <line x1="28" y1="6" x2="28" y2="64" />
      </g>
      <g transform="translate(80 0)">
        <text
          x="0"
          y="34"
          fill={wordmarkColor}
          fontFamily="'Bricolage Grotesque', 'Inter', system-ui, sans-serif"
          fontSize="22"
          fontWeight="600"
          letterSpacing="0.5"
        >
          BAUMPFLEGE
        </text>
        <text
          x="0"
          y="58"
          fill={subColor}
          fontFamily="'Bricolage Grotesque', 'Inter', system-ui, sans-serif"
          fontSize="14"
          fontWeight="400"
          letterSpacing="6"
        >
          STRAESSER
        </text>
      </g>
    </svg>
  );
}
